import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { useToast } from '@nx-frontend/shared/ui/toast';
import { $portalId } from '@nx-frontend/shared/store/portal-app';
import { $pageInfo } from '@nx-frontend/shared/store/portal-page';
import { PortalPersistentBlock } from '@nx-frontend/shared/types/portal-block';
import { isMac } from '@nx-frontend/shared/utils/is-mac';
import { getBlockChecksum } from './blockValidation';
import { ClipboardBlock } from './types';

interface BlockCopyToClipboardProps {
  blocks: PortalPersistentBlock[];
}

export const useBlockCopyToClipboard = () => {
  const t = useTranslations('customizer');
  const [portalId, { pageId }] = useUnit([$portalId, $pageInfo]);
  const { toast } = useToast();

  return async ({ blocks }: BlockCopyToClipboardProps) => {
    const data: ClipboardBlock = {
      type: 'clipboard#blockArray',
      sourcePortalId: portalId,
      sourcePageId: pageId,
      createdAt: Date.now(),
      blocks,
      checksum: getBlockChecksum(blocks),
    };

    try {
      await navigator.clipboard.writeText(JSON.stringify(data));
      toast({
        title: t('customizer-copy_block_toast', { pasteSystemCombination: (isMac() ? 'CMD' : 'CTRL') + '+V' }),
      });
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
};
